module.exports = __webpack_public_path__ + "static/media/beach_summer.e0ca9b37.jpg";